__turbopack_context__.v({
  "book_button": "IDPuna_book_button",
  "container": "IDPuna_container",
  "iframe_wrap": "IDPuna_iframe_wrap",
  "request_button": "IDPuna_request_button",
  "request_modal": "IDPuna_request_modal",
  "title": "IDPuna_title",
  "toolbar": "IDPuna_toolbar",
});
